var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 90,
    cy: 90,
    r: 90,
    fill: "#f92c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeBottom);
export default __webpack_public_path__ + "static/media/shape-bottom.e9fcd479d2e4c0ff4cd1137ebe0b37f6.svg";
export { ForwardRef as ReactComponent };